import PropTypes from 'prop-types';
import { Card, Image, Link } from '../../Atoms';
import Meta from '../Meta/Meta';

const ProjectCard = ({
  title,
  intro,
  image,
  url,
  className = '',
  type,
  technologies = [],
}) => {
  const metaItems = [];
  if (type) metaItems.push({ key: 'Type', value: type });
  if (technologies.length > 0) metaItems.push({ key: 'Technologies', value: technologies.join(' · ') });
  if (!title) return null;

  const cardContent = (
    <Card
      usage="interactive"
      className={`card-feature ${className}`}
    >
      <div className="card-feature-background">
        {image ? (
          <Image image={image} fit="cover" />
        ) : (
          <div className="card-feature-placeholder" />
        )}
        <div className="card-feature-overlay" />
      </div>
      <div className="block">
        <div className="block__body stack stack-normal on-dark">
          {metaItems.length > 0 && <Meta items={metaItems} />}
          {intro && <div className="text-block-support line-clamp-3">{intro}</div>}
          <div className="text-section-title line-clamp-2">{title}</div>
        </div>
      </div>
    </Card>
  );

  if (url) {
    return (
      <Link href={url} className="block no-underline">
        {cardContent}
      </Link>
    );
  }
  return cardContent;
};

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  intro: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.object,
  url: PropTypes.string,
  className: PropTypes.string,
};

export default ProjectCard;